(() => {
  if (window.bcpSpotlightInitialized) return;
  window.bcpSpotlightInitialized = true;
  let timer, controller, revision = 0;
  const dialog = () => document.getElementById('bcp-spotlight');
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-search-open]');
    if (trigger && dialog()?.showModal) {
      event.preventDefault();
      dialog().showModal();
      dialog().querySelector('input[type="search"]').focus();
    }
    if (event.target.closest('[data-search-close]')) dialog()?.close();
    if (event.target === dialog()) {
      const rect = dialog().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog().close();
    }
  });
  document.addEventListener('keydown', event => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k' && dialog()) {
      event.preventDefault();
      if (!dialog().open) dialog().showModal();
      dialog().querySelector('input[type="search"]').focus();
    }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('#bcp-spotlight input[name="q"]')) return;
    clearTimeout(timer); controller?.abort();
    const current = ++revision, term = event.target.value.trim(), modal = dialog();
    const results = modal.querySelector('[data-search-results]'), status = modal.querySelector('[role="status"]');
    results.replaceChildren();
    modal.querySelector('[data-search-popular]').hidden = !!term;
    status.textContent = term ? 'Searching…' : 'A great print starts with the perfect canvas.';
    if (!term) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const url = new URL(modal.dataset.suggestUrl, location.origin);
        url.search = new URLSearchParams({q: term, 'resources[type]': 'product,page,article', 'resources[limit]': '5', 'resources[limit_scope]': 'all', section_id: 'bcp-predictive-results'});
        const response = await fetch(url, {signal: controller.signal});
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (current !== revision) return;
        const content = html.querySelector('[data-predictive-count]');
        if (!content) throw new Error('Search unavailable');
        results.append(content);
        const count = Number(content.dataset.predictiveCount);
        status.textContent = count ? `${count} suggestions for “${term}”` : `No suggestions for “${term}”. Try a different word or search all results.`;
        const link = document.createElement('a');
        link.className = 'bcp-spotlight-all';
        link.href = modal.querySelector('form').action + '?' + new URLSearchParams({q: term, 'options[prefix]': 'last'});
        link.textContent = `View all results for “${term}” →`;
        results.append(link);
      } catch (error) {
        if (error.name !== 'AbortError' && current === revision) status.textContent = 'Press Enter to search the store.';
      }
    }, 220);
  });
})();
